export default __webpack_public_path__ + "static/media/plain-sticker-P.498b70fb.png";